module.exports = __webpack_public_path__ + "assets/check.90366fa8.svg";